import { CSSProperties, FC, ReactNode } from 'react';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';

interface SkeletonFadeProps {
    children: ReactNode;
    className?: string;
    fadeStart?: CSSProperties['height'];
    style?: CSSProperties;
}

const SkeletonFade: FC<SkeletonFadeProps> = ({ children, className, fadeStart = '20%', style }) => {
    const { token } = useAntDesignTheme();

    return (
        <div
            className={className}
            data-platform-skeleton-fade='true'
            style={{ minHeight: 0, position: 'relative', ...style }}
        >
            {children}
            <div
                aria-hidden
                data-platform-skeleton-fade-overlay='true'
                style={{
                    background: `linear-gradient(180deg, transparent ${fadeStart}, ${token.colorBgContainer} 100%)`,
                    inset: 0,
                    pointerEvents: 'none',
                    position: 'absolute',
                }}
            />
        </div>
    );
};

export default SkeletonFade;
